module.exports = __webpack_public_path__ + "assets/img/3ec524c0fe52571ed70c27750448bbc1.png";